import {gettersTypes as authGettersTypes} from '@/store/modules/auth/getters';

export const gettersTypes = {
  checkLoading: '[matrix-9-box] checkLoading',
  isAuthor: '[matrix-9-box] isAuthor',
  isCalibrationParticipant: '[matrix-9-box] isCalibrationParticipant',
  isCalibrated: '[matrix-9-box] isCalibrated',
  isFixed: '[matrix-9-box] isFixed',

  author: '[matrix-9-box] author',
  state: '[matrix-9-box] state',
  specs: '[matrix-9-box] specs',
  teams: '[matrix-9-box] teams',
  areas: '[matrix-9-box] areas',
  users: '[matrix-9-box] users',

  calibrationUsers: '[matrix-9-box] calibration users',
  excludedUsers: '[matrix-9-box] excluded users',
  includedUsers: '[matrix-9-box] included users',

  excludedUsersCount: '[matrix-9-box] excluded users count',
  includedUsersCount: '[matrix-9-box] included users count',

  competenceDirectory: '[matrix-9-box] competence directory',
  efficiencyDirectory: '[matrix-9-box] efficiency directory',
  areasDirectory: '[matrix-9-box] areas directory',
};

const getters = {
  [gettersTypes.checkLoading]: (state) => {
    return (loaderName) => {
      if (Array.isArray(loaderName)) {
        return (
          Object.keys(state.loadingObjCount).filter((key) => {
            return loaderName.includes(key) && state.loadingObjCount[key] === true;
          }).length > 0
        );
      }
      return state.loadingObjCount[loaderName] || false;
    };
  },

  [gettersTypes.isAuthor]: (state, getters, rootState, rootGetters) => {
    const authorUserId = getters[gettersTypes.author].user_id;
    const currentUserId = rootGetters[authGettersTypes.userId];

    if (!authorUserId || !currentUserId) return false;

    return authorUserId === currentUserId;
  },

  [gettersTypes.isCalibrationParticipant]: (state, getters, rootState, rootGetters) => {
    const calibrationUserIds = getters[gettersTypes.calibrationUsers].map((u) => u.user_id);
    const currentUserId = rootGetters[authGettersTypes.userId];

    return calibrationUserIds.includes(currentUserId);
  },

  [gettersTypes.isCalibrated]: (state) => {
    return state.matrixDetails?.header?.is_calibrated || false;
  },

  [gettersTypes.isFixed]: (state, getters) => {
    return getters[gettersTypes.state] === 'fixed';
  },

  [gettersTypes.author]: (state) => {
    return state.matrixDetails?.author || {};
  },

  [gettersTypes.state]: (state) => {
    return state.matrixDetails?.header?.state || '';
  },

  [gettersTypes.specs]: (state) => {
    return state.matrixDetails?.header?.specs || [];
  },

  [gettersTypes.teams]: (state) => {
    return state.matrixDetails?.header?.teams || [];
  },

  [gettersTypes.areas]: (state) => {
    return state.matrixDetails?.zones || {};
  },

  [gettersTypes.users]: (state) => {
    return state.matrixDetails?.data || [];
  },

  [gettersTypes.calibrationUsers]: (state) => {
    return state.matrixDetails?.calibrating_users || [];
  },

  [gettersTypes.excludedUsers]: (state, getters) => {
    return getters[gettersTypes.users].filter((user) => user.deleted);
  },

  [gettersTypes.includedUsers]: (state, getters) => {
    return getters[gettersTypes.users].filter((user) => !user.deleted);
  },

  [gettersTypes.excludedUsersCount]: (state, getters) => {
    return getters[gettersTypes.excludedUsers].length || 0;
  },

  [gettersTypes.includedUsersCount]: (state, getters) => {
    return getters[gettersTypes.includedUsers].length || 0;
  },

  [gettersTypes.competenceDirectory]: (state) => {
    return state.matrixDetails?.metadata?.ranks?.tests || {};
  },

  [gettersTypes.efficiencyDirectory]: (state) => {
    return state.matrixDetails?.metadata?.ranks?.targets || {};
  },

  [gettersTypes.areasDirectory]: (state) => {
    return state.matrixDetails?.metadata?.zones || {};
  },
};

export default getters;
